<!--联系我们-->
<template>
  <div class="count">
    <div class="contact-left" :style="contactStyle">
      <span class="c1">{{link}}</span>
      <br />
      <div class="c2">{{about}}</div>
    </div>
    <div class="contact-right">
      <div class="detail">
        <div>
          <span>{{phoneTitle}}：{{phone}}</span>
        </div>
        <div>
          <span>{{emailTitle}}：{{email}}</span>
        </div>
        <div>
          <span>{{addressTitle}}：{{address}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data() {
    //常量
    // let constant = JSON.parse(this.$supMainPageConfig).constant;
    // let contact = JSON.parse(this.$supMainPageConfig);
    return {
      // link: constant.link,
      // phone: contact.contactInfoShow.phone,
      // email: contact.contactInfoShow.email,
      // address: contact.contactInfoShow.address,
      // about: JSON.parse(this.$supMainPageConfig).catItemImg.info5.about
    };
  },
  methods: {},
  computed: {
         //store里面取数据
    ...mapGetters(['supMainPageConfig']),
  link: function()  {
      return JSON.parse(this.supMainPageConfig).constant.link;
    },
  phone: function()  {
      return JSON.parse(this.supMainPageConfig).contactInfoShow.phone;
    },
  email: function()  {
      return JSON.parse(this.supMainPageConfig).contactInfoShow.email;
    },
  address: function()  {
      return JSON.parse(this.supMainPageConfig).contactInfoShow.address;
    },
  about: function()  {
      return JSON.parse(this.supMainPageConfig).catItemImg.info5.about;
    },
  phoneTitle: function()  {
      return JSON.parse(this.supMainPageConfig).constant.phonetitle;
    },
  emailTitle: function()  {
    return JSON.parse(this.supMainPageConfig).constant.emailtitle;
    },
  addressTitle: function()  {
    return JSON.parse(this.supMainPageConfig).constant.addresstitle;
    },	


    contactStyle: function() {
      let contactImgSrc = JSON.parse(this.supMainPageConfig).catItemImg.info5
        .contactImgSrc;
      return {
        backgroundImage: "url(" + contactImgSrc + ")",
        backgroundRepeat: "no-repeat",
        width: "50%",
        height: "200px",
        borderRadius: "5px 0px 0px 5px"
      };
    }
  }
};
</script>

<style scoped lang="scss">
.count {
  width: 1200px;
  margin: 0 auto;
  margin-top: 64px;
  display: flex;
}
.contact-left {
  float: left;
  width: 50%;
  height: 200px;
}
.contact-left .c1 {
  height: 56px;
  font-size: 40px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 56px;
  letter-spacing: 2px;
  margin-top: 24px;
  margin-left: 24px;
}
.contact-left .c2 {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  margin-left: 24px;
  margin-top: 4px;
}
.contact-right {
  float: left;
  height: 200px;
  background: #ffffff;
  width:50%;
  border-radius: 0px 5px 5px 0px;
}
.contact-right .detail {
  margin-top: 57px;
  margin-left: 24px;

  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(107, 110, 131, 1);
  line-height: 22px;
  letter-spacing: 1px;
}
@media screen and ( max-width: 1200px ){
.count{
  width:900px;
}
.contact-left {
  float: left;
  width: 67% !important;
  height: 200px;
}
.contact-right {
  width:33%;
}
}
</style>